
import React from "react";
import SlideLayout from "../components/SlideLayout";

const IntroSlide = () => {
  return (
    <SlideLayout>
      <div className="space-y-6">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-cursive font-bold leading-tight mb-6 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600">
          Redefining the future of retail with Appella AI solutions
        </h1>
        <p className="text-3xl text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600 font-cursive tracking-tight max-w-3xl mx-auto">
          Transforming retail with AI agents that sound like your brand, speak any language, and work 24/7
        </p>
      </div>
    </SlideLayout>
  );
};

export default IntroSlide;
